import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import {
  ButtonWrapper,
  HeaderContainer,
  HeaderNav,
  HeaderWrapper,
  HeadLogo,
  NavItem,
  HeaderMobielButton,
} from "./style";

export const headerTab = [
  {
    title: "Home",
    direct: "/",
  },
  {
    title: "Galleries",
    direct: "/galleries",
  },
  {
    title: "Roadmap",
    direct: "/roadmap",
  },
];

type HeaderProps = {
  onMenuOpen: () => void;
};

const Header: React.FC<HeaderProps> = ({ onMenuOpen }) => {
  const navigate = useNavigate();
  const location = useLocation()
  const [header, setHeader] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 50) setHeader(true);
    else setHeader(false);
  };

  return (
    <HeaderWrapper className={header ? "header" : ""}>
      <HeaderContainer>
        <HeadLogo onClick={() => navigate("/")}>
          <img src="/assets/logo.png" alt="logo" />
        </HeadLogo>

        <HeaderNav>
          {headerTab.length > 0
            ? headerTab.map((item, key) => (
                <NavItem key={key}><Link to={item.direct}  className={location.pathname === item.direct ? "active" : "" }>{item.title} </Link></NavItem>
              ))
            : ""}
          <ButtonWrapper>
      <a href="https://app.stellartai.com/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'inherit'}}>Enter dAPP</a>
    </ButtonWrapper>
        </HeaderNav>
        <HeaderMobielButton onClick={() => onMenuOpen()}>
          <span></span>
          <span></span>
          <span></span>
        </HeaderMobielButton>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;
